// Carries the current page's query string (name/email/phone/... forwarded
// here by Gravity Forms' redirect confirmation) onto any link marked with
// data-forward-query — e.g. the "Calendly" button on the Danke page — so the
// next page can prefill its Calendly widget from the same values.
export function initQueryForwarding() {
    var currentParams = location.search.replace(/^\?/, '');

    if (!currentParams) {
        return;
    }

    var forwarded = false;

    document.querySelectorAll('[data-forward-query]').forEach(function (el) {
        // Elementor's Custom Attributes control sets this on the widget's
        // wrapper <div>, not the <a> it contains, so the actual link has to
        // be looked up rather than assumed to be the marked element itself.
        var link = el.tagName === 'A' ? el : el.querySelector('a');

        if (!link) {
            return;
        }

        var separator = link.href.indexOf('?') === -1 ? '?' : '&';
        link.href += separator + currentParams;
        forwarded = true;
    });

    // The data's already on the button's href at this point, so the address
    // bar no longer needs to show it — dropped without a reload so the URL
    // reads clean, matching how the values still make it to the next page.
    if (forwarded && window.history.replaceState) {
        window.history.replaceState(null, '', location.pathname + location.hash);
    }
}
